import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
    DEFAULT_PAGE_SIZE,
    CROSS_BASELINE_SEARCH_ATTRIBUTES,
    MOBILE_WINDOW_BREAKPOINT,
    CROSS_BASELINE_SEARCH_URL_PARAMS as URLParams
} from '../../../constants/constants';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';
import { actions as windowActions } from '../../../actions/windowActions';
import Routes from '../../../constants/routes';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Icon from '../../Common/Icon'
import { Paginator } from 'primereact/paginator';
import InputText from '../../Common/InputText';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import Notification from '../../Common/Notification';
import './CrossBaselineSearchPage.scss';
import { actions as baselineTaskActions } from '../../../actions/baselineTaskActions';
import * as types from '../../../constants/actionTypes';
import BaselineTaskDrawer from '../../BaselineTaskList/BaselineTaskDrawer';
import { Checkbox } from 'primereact/checkbox';
import BulkUpdateAttributesDrawer from './CrossBaselineTasks/BulkUpdateAttributesDrawer';

export class CrossBaselineSearchPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            searchAttributes: [
                { id: CROSS_BASELINE_SEARCH_ATTRIBUTES.TaskName, name: CROSS_BASELINE_SEARCH_ATTRIBUTES.TaskName },
                { id: CROSS_BASELINE_SEARCH_ATTRIBUTES.Department, name: CROSS_BASELINE_SEARCH_ATTRIBUTES.Department },
                { id: CROSS_BASELINE_SEARCH_ATTRIBUTES.Phase, name: CROSS_BASELINE_SEARCH_ATTRIBUTES.Phase },
                { id: CROSS_BASELINE_SEARCH_ATTRIBUTES.Discipline, name: CROSS_BASELINE_SEARCH_ATTRIBUTES.Discipline },
                { id: CROSS_BASELINE_SEARCH_ATTRIBUTES.AdditionalInfo, name: CROSS_BASELINE_SEARCH_ATTRIBUTES.AdditionalInfo },
                { id: CROSS_BASELINE_SEARCH_ATTRIBUTES.ContactInfo, name: CROSS_BASELINE_SEARCH_ATTRIBUTES.ContactInfo },
                { id: CROSS_BASELINE_SEARCH_ATTRIBUTES.LinkName, name: CROSS_BASELINE_SEARCH_ATTRIBUTES.LinkName },
                { id: CROSS_BASELINE_SEARCH_ATTRIBUTES.LinkUrl, name: CROSS_BASELINE_SEARCH_ATTRIBUTES.LinkUrl }
            ],
            searchParams: {
                subscriptionId: props.subscriptionId,
                searchTerm: (props.urlParams && props.urlParams.name) ? props.urlParams.name : "",
                searchAttribute: CROSS_BASELINE_SEARCH_ATTRIBUTES.TaskName,
                pageSize: DEFAULT_PAGE_SIZE,
                pageNumber: 1,
                sortBy: "name",
                sortDir: "asc",
                name: "",
                additionalInfo: ""
            },
            isFormValid: true,
            isLoading: false,
            tasks: [],
            checkedTasks: [],
            allTasksChecked: false,
            totalCount: 0,
            selectedTask: {},
            isDrawerOpen: false,
            formFilters: {
                isLoaded: false,
                departments: [],
                baselineJobTitles: [],
                communities: [],
                phases: [],
                taskTags: [],
                subscriptionFiles: [],
                certifiedTaskId: null,
                isStartDateActive: false,
                isTaskStepsActive: false,
                isTaskEffortActive: false,
                isTaskFeedbackActive: false,
                isTaskDependenciesActive: false,
                isProjectWidgetActive: false,
            }
        };
    }

    componentDidMount = () => {
        if (this.props.urlParams && this.props.urlParams.name) {
            this.search();
        }
    };

    isMobile = () => {
        return (this.props.windowWidth ?? 0) < MOBILE_WINDOW_BREAKPOINT;
    }

    onSearchTermChange = (e) => {
        this.setState({
            ...this.state,
            searchParams: {
                ...this.state.searchParams,
                [e.target.name]: e.target.value
            }
        });
    }

    onSearchAttributeChange = (searchAttributeId) => {
        this.setState({
            ...this.state,
            searchParams: {
                ...this.state.searchParams,
                searchAttribute: searchAttributeId
            }
        });
    }

    validateForm = () => {
        return this.state.searchParams.searchTerm && this.state.searchParams.searchTerm.trim().length;
    }

    onSearch = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        await this.search();
    }

    search = async () => {
        try {
            if (this.validateForm()) {
                this.setState({ isFormValid: true, isLoading: true });
                const response = await this.props.baselineTaskActions.searchCrossBaseline(this.state.searchParams);
                if (response.type === types.SEARCH_CROSS_BASELINE_SUCCESS) {
                    this.setState({ tasks: response.payload.results, totalCount: response.payload.totalCount });
                } else if (response.type === types.SEARCH_CROSS_BASELINE_FAILURE) {
                    this.setState({ tasks: [], totalCount: 0 });
                    Notification("error", "Error", response.payload.message);
                }
            } else {
                this.setState({ isFormValid: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ tasks: [], totalCount: 0 });
        } finally {
            this.setState({ isLoading: false });
        }
    }

    loadFormFilters = async (baselineId) => {
        try {
            const result = await this.props.baselineTaskActions.loadCrossBaselineFormFilters(this.props.subscriptionId, baselineId);
            const payload = result.payload;
            if (result.type === types.LOAD_CROSS_BASELINE_FORM_FILTERS_SUCCESS) {

                const formFilters = {
                    isLoaded: true,
                    departments: payload.departments,
                    baselineJobTitles: payload.baselineJobTitles,
                    communities: payload.communities,
                    phases: payload.phases,
                    taskTags: payload.taskTags,
                    subscriptionFiles: payload.subscriptionFiles,
                    certifiedTaskId: payload.certifiedTaskId,
                    isStartDateActive: payload.isStartDateActive,
                    isTaskStepsActive: payload.isTaskStepsActive,
                    isTaskEffortActive: payload.isTaskEffortActive,
                    isTaskFeedbackActive: payload.isTaskFeedbackActive,
                    isTaskDependenciesActive: payload.isTaskDependenciesActive,
                    isProjectWidgetActive: payload.isProjectWidgetActive
                };

                const newFilters = { ...this.state.formFilters, ...formFilters }
                this.setState({ formFilters: newFilters });

            } else if (result.type === types.LOAD_CROSS_BASELINE_FORM_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        }
    }

    onSort = ({ sortField, sortOrder }) => {
        const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
        const newSearchParams = {
            ...this.state.searchParams,
            sortBy: sortBy,
            sortDir: sortDir
        };

        this.setState({ searchParams: newSearchParams }, this.search);
    }

    onSelectTask = (e) => {
        const checkboxToggle = (
            e.originalEvent.target.innerHTML.indexOf('p-checkbox-box') >= 0
            || e.originalEvent.target.className.indexOf('p-checkbox-box') >= 0
            || e.originalEvent.target.className.indexOf('p-checkbox-icon') >= 0
        );
        if (checkboxToggle) {
            // Any part of the checkbox cell was clicked, so check the box instead of selecting the row
            this.onToggleCheckedTaskBaseline(e.value.id);
        } else {
            const baselineName = (e.originalEvent.target.outerHTML.indexOf('baseline-name') >= 0);
            if (baselineName) {
                this.onBaselineNameClick(e.value);
            } else {
                this.showTask(e.value);
            }
        }
    }

    showTask = async (rowData) => {
        // Auto-close and reopen the drawer to trigger all drawer lifecycle events properly
        this.setState({ selectedTask: rowData, isDrawerOpen: false });
        await this.loadFormFilters(rowData.baselineId);
        this.setState({ isDrawerOpen: true });
    }

    milestoneTemplate = (rowData) => {
        if (rowData.isMilestone) {
            return <div className="text-warning" title="Milestone Task">&#x25C6;</div>;
        }
    }

    baselineNameTemplate = (rowData) => {
        return <span className="baseline-name name">{rowData.baselineName}</span>
    }

    onBaselineNameClick = (rowData) => {
        this.props.history.push(Routes.BaselineTaskList + "/?bid=" + rowData.baselineId);
    }

    taskNameTemplate = (rowData) => {
        return <span className="name">{rowData.name}</span>
    }

    onDrawerComplete = () => {
        if (this.state.checkedTasks && this.state.checkedTasks.length > 0) {
            this.clearAllCheckedTasks();
            this.setState({ isBulkUpdateAttributesDrawerOpen: false });
        }

        this.setState({ isDrawerOpen: false });
        this.onSearch(new Event('event'));
    }

    onDrawerCancel = () => {
        this.setState({ isDrawerOpen: false });
    }

    onPageChange = (e) => {
        this.setState({
            searchParams: {
                ...this.state.searchParams,
                pageNumber: e.page + 1
            }
        }, this.search);
    }

    onToggleCheckedTask = (baselineTask) => {
        this.onToggleCheckedTaskBaseline(baselineTask.id);
    }

    checkboxTemplate = (rowData) => {
        return <Checkbox name="checkbox" onChange={() => this.onToggleCheckedTask(rowData)} checked={rowData.IsChecked}></Checkbox>
    }

    clearAllCheckedTasks = () => {
        const baselineTasks = this.state.checkedTasks.map(item => { return { ...item, IsChecked: false } });
        this.setState({
            checkedTasks: [],
            allTasksChecked: false,
            baselineTasks: baselineTasks
        });
    }

    onToggleCheckedTaskBaseline = (baselineTaskId) => {
        const tasks = this.state.tasks;
        let checkedTasks = [];

        const newTasks = tasks.map((item) => {
            let task = { ...item };
            if (item.id === baselineTaskId) {
                task.IsChecked = !item.IsChecked;
            }

            if (task.IsChecked) {
                checkedTasks.push(task);
            }
            return task;
        });

        // If we've manually checked all tasks, also check the master checkbox
        const allTasksChecked = (newTasks.length === checkedTasks.length);

        this.setState({
            checkedTasks: checkedTasks,
            tasks: newTasks,
            allTasksChecked: allTasksChecked
        });
    }

    onBulkUpdateAttributes = async () => {
        if (this.state.checkedTasks.length > 1) {
            this.setState({ selectedTask: {} });
        }

        this.setState({ isBulkUpdateAttributesDrawerOpen: true });
        await this.loadFormFilters(this.state.checkedTasks[0].baselineId);
    }

    onBulkUpdateAttributesCancel = () => {
        this.setState({ isBulkUpdateAttributesDrawerOpen: false });
    }

    onMasterCheckboxToggle = () => {
        // Toggle the master checkbox to checked or unchecked
        const allTasksChecked = !this.state.allTasksChecked;

        // Check or uncheck all baseline tasks, based on its newly-toggled state
        const newTasks = this.state.tasks.map(item => { return { ...item, IsChecked: allTasksChecked } });
        const checkedTasks = allTasksChecked ? newTasks.slice() : [];

        this.setState({
            checkedTasks: checkedTasks,
            tasks: newTasks,
            allTasksChecked: allTasksChecked
        });
    }

    render() {
        const masterCheckbox = <div>
            <Checkbox name="checkbox" onChange={() => this.onMasterCheckboxToggle()} checked={this.state.allTasksChecked}></Checkbox>
        </div>;
        const isBulkMode = this.state.checkedTasks && this.state.checkedTasks.length > 0;
        const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

        return (
            <div className="task-list-wrapper cross-baseline-search-page">
                <div className="task-list-header">
                    <div className="search-wrapper">
                        <form noValidate className={`d-flex gap-3 justify-content-end ${this.state.isFormValid ? "" : "was-validated"}`}>
                        {isBulkMode &&
                         <Fragment>
                            <div className="icon d-flex gap-1 mt-2 bulk-update-div" onClick={this.onBulkUpdateAttributes}>
                                <Icon name="pencil-alt" /><span>Update Attributes</span>
                            </div>
                        </Fragment>
                        }
                            <InputText bootstrapClass="search-term" name="searchTerm" placeholder="Task Search" type="text"
                                value={this.state.searchParams.searchTerm}
                                onChange={this.onSearchTermChange}
                                isRequired={true}
                                pattern=".*\S+.*"
                                errorMessage="Search term is required.  Use * to search for all."
                            />
                            <MultiSelectBox name="searchAttribute" idField="id" valueField="name" label=""
                                options={this.state.searchAttributes}
                                onChange={this.onSearchAttributeChange}
                                selectedValues={this.state.searchParams.searchAttribute}
                                className="search-attribute"
                                isMulti={false}
                            />
                            <button className="btn btn-primary d-flex align-items-center gap-2" onClick={this.onSearch}>Search</button>
                        </form>
                    </div>
                </div>


                <LoadingIndicator isLoading={this.state.isLoading} hideWhileLoading={true}>
                    <div className="task-list-results-table">
                        <DataTable
                            className="p-datatable-sm p-datatable-striped"
                            value={this.state.tasks}
                            selectionMode="single"
                            onSelectionChange={this.onSelectTask}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={this.onSort}>
                            <Column field="IsChecked" header={masterCheckbox} body={this.checkboxTemplate} style={{ textAlign: 'center', width: '30px' }} />
                            <Column field="isMilestone" body={this.milestoneTemplate} style={{ textAlign: 'center', width: '20px' }} />
                            <Column field="baselineName" header="Baseline" body={this.baselineNameTemplate} style={{ width: '140px' }} sortable={true} />
                            <Column field="name" header="Task" body={this.taskNameTemplate} sortable={true} />
                            <Column field="targetWeeksOut" header="Target Weeks Out" style={{ textAlign: 'left', width: '135px' }} sortable={true} />
                            <Column field="departmentName" header="Department" style={{ width: '160px' }} sortable={true} />
                        </DataTable>
                        {
                            this.state.totalCount > this.state.searchParams.pageSize &&
                            <Paginator
                                rows={this.state.searchParams.pageSize}
                                totalRecords={this.state.totalCount}
                                first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
                                onPageChange={this.onPageChange} />
                        }
                        <div className="results-count">Total records: {this.state.totalCount}</div>
                    </div>
                    {
                        this.state.isDrawerOpen &&
                        <BaselineTaskDrawer
                            subscriptionId={this.props.subscriptionId}
                            baselineId={this.state.selectedTask.baselineId}
                            taskId={this.state.selectedTask.id}
                            onComplete={this.onDrawerComplete}
                            onCancel={this.onDrawerCancel}
                            onUpdateList={this.search}
                            formFilters={this.state.formFilters}
                            baselineTaskActions={this.props.baselineTaskActions}
                            isMobile={this.isMobile()}
                        />
                    }
                </LoadingIndicator>
                {this.state.isBulkUpdateAttributesDrawerOpen &&
                    <BulkUpdateAttributesDrawer
                        checkedTasks={this.state.checkedTasks}
                        onComplete={this.onDrawerComplete}
                        onCancel={this.onBulkUpdateAttributesCancel}
                        baselineTaskActions={this.props.baselineTaskActions}
                        departments={this.props.departments}
                        jobTitles={this.props.baselineJobTitles}
                        communities={this.props.communities}
                        phases={this.props.phases}
                        subscriptionId={this.props.subscriptionId}
                        baselineId={this.state.selectedTask.baselineId}
                        taskId={this.state.selectedTask.id}
                        onUpdateList={this.search}
                        formFilters={this.state.formFilters}
                        isMobile={this.isMobile()}
                    />
                }
            </div>
        );
    }
}

CrossBaselineSearchPage.propTypes = {
    windowWidth: PropTypes.number,
    subscriptionId: PropTypes.string.isRequired,
    baselineTaskActions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    urlParams: PropTypes.object.isRequired,
    departments: PropTypes.array,
    baselineJobTitles: PropTypes.array,
    communities: PropTypes.array,
    phases: PropTypes.array
};

function mapStateToProps(state, ownProps) {

    let urlParams = {
        name: ''
    }

    const searchParams = new URLSearchParams(ownProps.location.search);

    if (searchParams.has(URLParams.name)) {
        urlParams.name = searchParams.get(URLParams.name);
    }

    return {
        windowWidth: state.window.width,
        subscriptionId: state.user.currentSubscriptionId ? state.user.currentSubscriptionId.toString() : '',
        history: ownProps.history,
        urlParams: urlParams
    }
}

function mapDispatchTpProps(dispatch) {
    return {
        baselineTaskActions: bindActionCreators(baselineTaskActions, dispatch),
        windowActions: bindActionCreators(windowActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchTpProps)(CrossBaselineSearchPage);
